import { socials } from "./postsData/socials";
import question from "../../assets/images/Posts/1/question.png";
import shoulders from "../../assets/images/Posts/1/shoulders.png";
import deathReasons from "../../assets/images/Posts/1/death_reasons.jpg";
import logo from "../../assets/images/Posts/1/logo.jpg";
import shame from "../../assets/images/Posts/1/shame.jpg";
import React from "react";

export default function Posts() {
  return (
    <section className="posts-wrapper" id="нашацель">
      <h2>Наша цель</h2>
      <h3>Вы знали, что одинокие люди подвержены риску преждевременной смерти
            на 30% чаще, чем те, у которых есть пара? Нет? <br/> А то, что из-за этой
            причины на 30% возрастает риск сердечных заболеваний и инсульта?</h3>
      <img src={ deathReasons } alt="death reasons" />
      <div className="post-content">
        <div>
          <div className="question">
            <span>Возникает закономерный вопрос: &#34;Как в 21-ом веке человек может быть одиноким?&#34;</span>
            <img src={ question } alt="question"/>
          </div>
          <div className="socials-wrapper">
            <span>Мир уже придумал массу социальных сетей, сайтов знакомств, мессенджеров, но они не
              справились с проблемой одиночества!</span>
            <div className="socials">
              { (window.screen.width > 1024 ? socials :
                window.screen.width <= 280 ? socials.slice(0, 6) :
                  window.screen.width <= 425 ? socials.slice(0, 7) : socials.slice(0, 14)).map(item =>
                <img src={ item } key={ item } alt="social-logo"/>
              ) }
            </div>
          </div>
          <div className="post-typical-part">
            <img src={ shoulders } alt="why??"/>
            <span>Некогда прорывные, изменившие всё и объединившие массы, социальные сети,
              превратились в платформы развлечений. Их используют, чтобы смотреть &#34;мемасики&#34;
              и &#34;видосики&#34;. </span>
          </div>
          <div className="post-typical-part">
            <span>Сайты и приложения для знакомств в основном решают &#34;постельные&#34; вопросы.
              А мессенджеры используют для общения только со своими контактами.</span>
            <img src={ shame } alt="стыд"/>
          </div>
          <span>Так где же человеку сейчас найти место для общения? Где он может быть уверен, что в
          любую минуту сможет поговорить?</span>
        </div>
      </div>
      <div>
        <p>У нас есть ответ на этот вопрос:</p>
        <img src={ logo } className="logo" alt="logo"/>
        <p>Мы работаем именно над тем, чтобы люди перестали быть одинокими!</p>
      </div>
    </section>
  );
}
